import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'printlayout2',
  templateUrl: './printlayout2.component.html',
  styleUrls: ['./printlayout2.component.scss']
})

export class  Printlayout2Component implements OnInit {
  


 

 
  constructor(private route: ActivatedRoute, private router: Router,) { }


  ngOnInit() {

   
  }
  

 
 
 


 
}
